const SCRIPT_SRC_PATTERN = 'sienna-accessibility';

function findAswScript(): HTMLScriptElement | null {
    if (document.currentScript) {
        return document.currentScript as HTMLScriptElement;
    }

    const scripts = Array.from(document.querySelectorAll<HTMLScriptElement>('script[src]'));
    return scripts.find(s => s.src.includes(SCRIPT_SRC_PATTERN)) ?? null;
}

export function getScriptDataAttribute(attr: string): string | null {
    const key = `data-asw-${attr}`;
    const script = findAswScript();

    if (script?.hasAttribute(key)) {
        return script.getAttribute(key);
    }

    return document.querySelector<HTMLElement>(`[${key}]`)?.getAttribute(key) ?? null;
}
